import { ChangeDetectionStrategy, Component, input, output, type TemplateRef } from '@angular/core';

import { renderComponentContract } from '@core/common-legacy';

import { WysiwygLink } from '../../wysiwyg-extensions/link/wysiwyg-link.types';

export enum KnownInserts {
  Gdpr = 'gdpr-inserts',
  Kununu = 'kununu-inserts',
  Questionaires = 'questionaries-inserts',
  Scheduler = 'scheduler-inserts',
  EmailTemplates = 'email-templates-inserts',
}

@Component({ template: '' })
export abstract class RedactorInsertsContractComponent {
  public hasBackAction = input(false);
  public isConsentRequestShow = input(true);
  public insideTemplate = input<TemplateRef<any>>();
  public isProsemirror = input(false);
  public kind = input<string>();

  public back = output<void>();
  public settings = output<string>();
  public closeDropdown = output<void>();
  public insertLink = output<WysiwygLink>();
  public emailTemplateChoose = output<unknown>();
  public saveAsTemplate = output<void>();
}

@Component({
  template: ``,
  selector: 'redactor-inserts-outlet',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RedactorInsertsComponentOutletComponent extends RedactorInsertsContractComponent {
  public componentId = input<string>('');

  constructor() {
    super();
    renderComponentContract(RedactorInsertsContractComponent, this);
  }
}
